// ABOUTME: Avatar menu in the header: account, Settings, Admin Panel, Sign out.
// ABOUTME: Destructive actions live on the Settings page, not in a dropdown.

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

interface UserMenuProps {
  user: { email: string; photoURL?: string } | null;
  onSignOut: () => void;
  isAdmin: boolean;
}

const UserMenu: React.FC<UserMenuProps> = ({ user, onSignOut, isAdmin }) => {
  const [avatarError, setAvatarError] = useState(false);

  if (!user) return null;

  return (
    <div className="relative ml-3">
      <Menu as="div" className="relative">
        <MenuButton className="relative flex max-w-xs items-center rounded-full bg-[var(--color-bg-secondary)] text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-offset-2 border border-[var(--color-border)]">
          <span className="absolute -inset-1.5" />
          <span className="sr-only">Open user menu</span>
          {user.photoURL && !avatarError ? (
            <img
              alt="User avatar"
              src={user.photoURL}
              className="w-8 h-8 rounded-full object-cover"
              onError={() => setAvatarError(true)}
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-[var(--color-bg-hover)] flex items-center justify-center text-[var(--color-text-muted)] text-sm font-medium">
              {user.email.charAt(0).toUpperCase()}
            </div>
          )}
        </MenuButton>

        <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-[var(--radius-lg)] bg-[var(--color-bg-secondary)] py-1 ring-1 ring-black/5 focus:outline-none border border-[var(--color-border)]">
          {/* User email */}
          <div className="px-4 py-2.5 border-b border-[var(--color-border)]">
            <div className="text-sm font-medium truncate text-[var(--color-text-primary)]">
              {user.email}
            </div>
            {isAdmin && (
              <div className="text-xs text-[var(--color-accent)] mt-0.5 font-medium">Admin</div>
            )}
          </div>

          {/* Navigation items */}
          <div className="py-1">
            <MenuItem>
              {({ active }) => (
                <Link
                  to="/settings"
                  className={`block px-4 py-2 text-sm transition-colors
                    ${active ? "bg-[var(--color-bg-hover)]" : ""}
                    text-[var(--color-text-primary)]`}
                >
                  Settings
                </Link>
              )}
            </MenuItem>
            {isAdmin && (
              <MenuItem>
                {({ active }) => (
                  <Link
                    to="/admin"
                    className={`block px-4 py-2 text-sm transition-colors
                      ${active ? "bg-[var(--color-bg-hover)]" : ""}
                      text-[var(--color-text-primary)]`}
                  >
                    Admin Panel
                  </Link>
                )}
              </MenuItem>
            )}
          </div>

          <div className="border-t border-[var(--color-border)] py-1">
            <MenuItem>
              {({ active }) => (
                <button
                  onClick={onSignOut}
                  className={`w-full text-left px-4 py-2 text-sm transition-colors
                    ${active ? "bg-[var(--color-bg-hover)]" : ""}
                    text-[var(--color-text-primary)]`}
                >
                  Sign out
                </button>
              )}
            </MenuItem>
          </div>
        </MenuItems>
      </Menu>
    </div>
  );
};

export default UserMenu;
